import { ImageIcon } from "shared-components/Components/CustomIcons/ImageIcon/web";
import "./styles.less";

export const PropertyCardSkeleton = ({ big = false }) => {
	return (
		big ? (
			<div className={"property-card-skeleton big"} >
				<div className="cardImgSkelleton">
					<ImageIcon />
				</div>
				<div className={"property-card-body"}>
					<span style={{ width: '18%', height: 30, marginTop: 20 }}></span>
					<span style={{ width: '20%' }}></span>
					<div style={{ display: 'flex', gap: 15, marginBottom: 10, marginTop: 10 }}>
						<span style={{ width: '10%', height: 25 }}></span>
						<span style={{ width: '10%', height: 25 }}></span>
						<span style={{ width: '10%', height: 25 }}></span>
					</div>
					<span style={{ width: '38%' }}></span>
					<span style={{ marginBottom: -5 }}></span>
					<span style={{ marginBottom: -5 }}></span>
					<span style={{ width: '61%', marginBottom: 0 }}></span>

				</div>

			</div>
		) : (
			<div className={"property-card-skeleton"} >
				<div className="cardImgSkelleton">
					<ImageIcon />
				</div>
				<div className={"property-card-body"}>
					<span style={{ width: '38%' }}></span>
					<span></span>
					<span></span>
					<span style={{ width: '61%' }}></span>
				</div>

			</div>
		)


	);
}